import getNetworkInfo from 'mini-network-info/lib/utils/getNetworkInfo';
import { getPayloadForAppRenderBootAnalysis } from './getPayloadForAppRenderBootAnalysis';

/**
 * Function to generate the payload used for LCP and LSR
 * @param customPayloadToLog
 */
/* eslint-disable-next-line @typescript-eslint/no-explicit-any --
 * See aka.ms/mini-lint-errors
 *	> Unexpected any. Specify a different type. */
export async function getCustomPayloadForAppRenderBootAnalysis(customPayloadToLog?: any) {
    const payloadForAnalysis = await getPayloadForAppRenderBootAnalysis();

    const networkInfo = getNetworkInfo();

    const customPayloadForAnalysis = {
        ...payloadForAnalysis,

        /**
         * Any custom payload to be logged as part of LCP by the user of trackLCP
         */
        ...customPayloadToLog,

        /**
         * RTT
         */
        rtt: networkInfo?.rtt,

        /**
         * Downlink value
         */
        dl: networkInfo?.downlink,

        /**
         * Network effective type
         */
        et: networkInfo?.effectiveType,
    };

    return customPayloadForAnalysis;
}
